import axios from '../services/axiosConfig';

const API_URL = process.env.REACT_APP_API_URL;

// Get all menu items
export const getAllMenus = async () => {
  try {
    const response = await axios.get(`${API_URL}/menus`);
    return response.data;
  } catch (error) {
    console.error('Error fetching menus:', error);
    throw error;
  }
};

// Get menu list from the specific API endpoint
export const getMenuList = async () => {
  try {
    const response = await axios.get(`${API_URL}/GetMenuList`);

    // Check if response.data exists and return it in the expected format
    if (response.data) {
      // If data has allMenus property and it's an array, return it
      if (response.data.allMenus && Array.isArray(response.data.allMenus)) {
        return response.data.allMenus;
      }
      // If data is already an array, return it
      else if (Array.isArray(response.data)) {
        return response.data;
      } 
      // If data has a specific property that contains the menu array
      else if (response.data.menus && Array.isArray(response.data.menus)) {
        return response.data.menus;
      }
      // If data is an object with menu items as properties
      else if (typeof response.data === 'object' && !Array.isArray(response.data)) {
        // Try to convert the object to an array
        const menuArray = Object.values(response.data);
        if (menuArray.length > 0 && typeof menuArray[0] === 'object') {
          return menuArray;
        }
      }
    }
    
    // If we couldn't parse the response in a meaningful way, return an empty array
    console.error('Unexpected response format from API:', response.data);
    return [];
  } catch (error) {
    console.error('Error fetching menu list:', error);
    return []; // Return empty array on error instead of throwing
  }
};

// Get menu by ID
export const getMenuById = async (menuId) => {
  try {
    const response = await axios.get(`${API_URL}/menus/${menuId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching menu with ID ${menuId}:`, error);
    throw error;
  }
};

// Create a new menu item
export const createMenu = async (menuData) => {
  try {
    // Format the request body according to the required format
    const requestBody = {
      parentMenuId: menuData.parentMenuId,
      menuName: menuData.menuName,
      description: menuData.description,
      sequence: menuData.sequence
    };

    const response = await axios.post(`${API_URL}/AddMenu`, requestBody);

    return {
      success: response.data.success,
      message: response.data.message,
      errorMessage: response.data.errorMessage
    };
  } catch (error) {
    console.error('Error creating menu:', error);
    return {
      success: false,
      message: null,
      errorMessage: error.response?.data?.errorMessage || error.message || 'Failed to create menu'
    };
  }
};

// Update an existing menu item
export const updateMenu = async (menuId, menuData) => {
  try {
    // Format the request body according to the required format
    const requestBody = {
      menuName: menuData.menuName,
      description: menuData.description,
      sequence: menuData.sequence,
      isActive: menuData.isActive
    };

    const response = await axios.put(`${API_URL}/${menuId}`, requestBody);

    return {
      success: response.data.success,
      message: response.data.message,
      errorMessage: response.data.errorMessage
    };
  } catch (error) {
    console.error(`Error updating menu with ID ${menuId}:`, error);
    return {
      success: false,
      message: null,
      errorMessage: error.response?.data?.errorMessage || error.message || `Failed to update menu with ID ${menuId}`
    };
  }
};

// Delete a menu item
export const deleteMenu = async (menuId) => {
  try {
    const response = await axios.delete(`${API_URL}/menus/${menuId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting menu with ID ${menuId}:`, error);
    throw error;
  }
};
